<form [formGroup]="connectionForm">
    <!-- Step 1: Prepare Microsoft Entra -->
    <ng-container *ngIf="currentStep === 1">
        <div class="title" mat-dialog-title>Prepare Microsoft Entra</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">Please watch the following video to learn how to set up Microsoft Entra before proceeding:</div>
                <div class="video-container" style="margin: 16px 0;">
                    <iframe width="100%" height="315" src="https://www.youtube.com/embed/V_QgKvNUJv0"
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div>
                <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="goToStep2()"
                    data-cy="entra-ready-btn">I am ready. Start connecting</button>
            </div>
        </div>
    </ng-container>

    <!-- Step 2: Setup SSO Domain -->
    <ng-container *ngIf="currentStep === 2">
        <div class="title" mat-dialog-title>Setup SSO Domain</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">Enter a domain prefix for your SSO configuration.</div>
                <div class="form-hint" style="font-size: 13px; color: #757575; margin-bottom: 12px;">(Domain is shared by all SSO platforms.)</div>
                <mat-form-field appearance="outline" class="form-field domain-field">
                    <mat-label>Domain Prefix</mat-label>
                    <input matInput placeholder="Enter domain prefix" formControlName="domainPrefix"
                        (blur)="validateDomainPrefix()" data-cy="entra-domain-prefix-input">
                    <span matSuffix class="domain-suffix">.{{domain}}</span>
                    <mat-error *ngIf="connectionForm.get('domainPrefix').hasError('required')">
                        Domain prefix is required
                    </mat-error>
                    <mat-error *ngIf="connectionForm.get('domainPrefix').hasError('pattern')">
                        Invalid domain prefix format
                    </mat-error>
                    <mat-error *ngIf="connectionForm.get('domainPrefix').hasError('unavailable')">
                        {{ domainErrorMessage }}
                    </mat-error>
                </mat-form-field>
                <div class="validation-status" *ngIf="isValidating">
                    <mat-spinner diameter="16"></mat-spinner>
                    <span>Checking availability...</span>
                </div>
                <div class="validation-status success" *ngIf="isDomainValid && !isValidating">
                    <mat-icon>check_circle</mat-icon>
                    <span>Domain is available</span>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="footer-buttons">
                <button mat-stroked-button class="rubii-btn back-btn" (click)="goToStep1()"
                    data-cy="entra-back-btn">Back</button>
                <button mat-raised-button class="rubii-btn add-btn" color="primary"
                    [disabled]="!isDomainValid || isValidating" (click)="goToStep3()"
                    data-cy="entra-next-btn">Next</button>
            </div>
        </div>
    </ng-container>

    <!-- Step 3: Enter Credentials -->
    <ng-container *ngIf="currentStep === 3">
        <div class="title" mat-dialog-title>Enter Entra Credentials</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">Enter your Microsoft Entra ID application credentials.</div>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Tenant ID</mat-label>
                    <input matInput placeholder="Enter Tenant ID" formControlName="tenantId"
                        data-cy="entra-tenant-id-input">
                    <mat-error
                        *ngIf="connectionForm.get('tenantId').errors && (connectionForm.get('tenantId').touched || connectionForm.get('tenantId').dirty)">
                        Tenant ID is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Client ID</mat-label>
                    <input matInput placeholder="Enter Client ID" formControlName="clientId"
                        data-cy="entra-client-id-input">
                    <mat-error
                        *ngIf="connectionForm.get('clientId').errors && (connectionForm.get('clientId').touched || connectionForm.get('clientId').dirty)">
                        Client ID is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Client Secret</mat-label>
                    <input type="password" matInput placeholder="Enter Client Secret" formControlName="clientSecret"
                        data-cy="entra-client-secret-input">
                    <mat-error
                        *ngIf="connectionForm.get('clientSecret').errors && (connectionForm.get('clientSecret').touched || connectionForm.get('clientSecret').dirty)">
                        Client Secret is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="footer-buttons">
                <button mat-stroked-button class="rubii-btn back-btn" (click)="goToStep2()"
                    data-cy="entra-back-btn">Back</button>
                <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()"
                    data-cy="entra-connect-btn">Connect Data Source</button>
            </div>
        </div>
    </ng-container>
</form>
